module.exports = __webpack_public_path__ + "img/127-Scharzgrau SFTN Mat.jpg";